<template>
  <v-main class="main-container">
    <EventDetails />
  </v-main>
</template>

<script>
import EventDetails from "@/components/templates/EventDetails";

export default {
  components: { EventDetails },
};
</script>